$(function(){
    "use strict";

    if (Modernizr.touch) {

        $(document).on('click', '.userbar__profile .userbar__item__element', function(event) {
            event.preventDefault();

            $(this).parents('.userbar__profile')
                .addClass('userbar__profile_dropped');
        });

        $(document).on('click', function() {
            $('.userbar__profile_dropped')
                .removeClass('userbar__profile_dropped');
        });

        $(document).on('click', '.userbar__profile', function(event) {
            event.stopPropagation()
        });
    }
});